import React from "react";
import { Card, Button, Modal, List as AntList, Col ,Icon} from "antd";
import PropTypes from "prop-types";
import cx from "classnames";
import { Map, List } from "immutable";
import { LoaderSkeleton, Table } from "../../components";
import {APPLICANT_VERIFICATION_COLS} from "../../constants/table-columns";
import {RCU_VERIFICATION_STATUS_TYPES} from "../../constants/enums";
import { DocumentViewer } from "components/index";
import "styles/applicant-verification.css";

const ListItem = AntList.Item;
class ApplicantVerificationTable extends React.Component{
    
    tableColumns = APPLICANT_VERIFICATION_COLS;

    state = {
        selectedDocType: null,
        openDocSelectionModal: false,
        selectedDoc: null,
        selectedRequest: null,
        selectedFileId: null,
        showDoc: false
    };

    isLoading = () => false;

    verifyDetails = (type, data) => {
        let details = {
            name: data.associate,
            id: data.associate_id,
            aadhar_no: data.aadhar_no,
            phone_no: data.phone_no,
            pan_no: data.pan_no,
            email_id: data.email_id,
            pan: {
                request_id: data.pan && data.pan.request_id,
                verification_source: data.pan && data.pan.verification_source,
                verification_status: data.pan && data.pan.verification_status
            },
            phone: {
                request_id: data.phone && data.phone.request_id,
                verification_source: data.phone && data.phone.verification_source,
                verification_status: data.phone && data.phone.verification_status
            },
            aadhar: {
                request_id: data.aadhar && data.aadhar.request_id,
                verification_source: data.aadhar && data.aadhar.verification_source,
                verification_status: data.aadhar && data.aadhar.verification_status
            },
            email: {
                request_id: data.email && data.email.request_id,
                verification_source: data.email && data.email.verification_source,
                verification_status: data.email && data.email.verification_status
            }
        };
        this.props.verifyDetails(type, details);
    }

    updateSelectedDocument = (file) => {
        this.setState({
            selectedDoc: file
        }, () => {
            this.toggleDocumentSelectionModal(null);
        });
    }

    toggleDocumentSelectionModal = (document) => {
        this.setState({
            selectedDocType: document,
            openDocSelectionModal: !this.state.openDocSelectionModal
        });
    }

    showDocument = (id, doc) => {
        this.setState({
            showDoc: true,
            fileUrl: doc.file
        });
    }

    openDocumentViewer = () => {
        return (
            <Modal
                visible={this.state.showDoc}
                onCancel={() => {
                    this.setState({
                        showDoc: false
                    });
                }}
                onOk={() => {}}
                title={"File View"}
                width={"fit-content"}
            >
                <DocumentViewer
                    url={this.state.fileUrl}
                    width={600}
                    height={800}
                />
            </Modal>
        );
    }

    getTitle = (doc) => {
        return (
            <Col
                span={24}
                className={
                    "d-flex flex-direction-row justify-content-space-between"
                }
            >
                <div
                    style={{
                        textOverflow: "ellipsis",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#000000"
                    }}
                >
                    {doc.document && doc.document.document_name}
                </div>
                <div style={{
                    color: "#eb5757",
                    background: "transparent",
                    cursor: "pointer",
                    fontSize: 12
                }}>
                    <Button type={"link"} icon={"eye"} onClick={() => this.showDocument(doc.id, doc)}>
                        View
                    </Button>
                </div>
            </Col>
        );
    }

    selectFile = file => this.setState({
        selectedFileId: file.id
    });
    isSelected = file => file && file.id === this.state.selectedFileId;

    showDocumentSelectionModal = () => {
        let documents = this.props.documents.filter(_ => _.file !== null);
        if(this.state.selectedDocType == "aadhar") {
            documents = documents.filter(_ => [8, 13].includes(_.document && _.document.id));
        } else if(this.state.selectedDocType == "pan") {
            documents = documents.filter(_ => [7, 12].includes(_.document && _.document.id));
        }
        return (
            <Modal
                visible={this.state.openDocSelectionModal}
                closable={true}
                className={"document-search"}
                title={`Select Appropriate ${this.state.selectedDocType == "aadhar" ? "Aadhar" : "Pan"}`}
                destroyOnClose
                onCancel={this.toggleDocumentSelectionModal}
                onOk={this.updateSelectedDocument}
            >
                <div className="p-10">
                    {
                        documents && documents.size ?
                            (
                                <AntList
                                    grid={{column: 1}}
                                >
                                    {documents.map(_ => (
                                        <ListItem
                                            className={cx("item-unclicked", {
                                                ["clicked-item"]: this.isSelected(_)
                                            })}
                                            key={_.id}
                                        >
                                            <Card
                                                title={this.getTitle(_)}
                                                onClick={this.selectFile.bind(null, _)}
                                                className={
                                                    "padless-card no-shadow w-100 document-list"
                                                }
                                            />
                                        </ListItem>
                                    )).toList().toArray()}
                                </AntList>
                            )
                            : null
                    }
                </div>
            </Modal>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.showDocumentSelectionModal()}
                {this.openDocumentViewer()}
                <LoaderSkeleton loading={this.isLoading()}>
                    <Card
                        className={"padless-card m-10"}
                        title={"Applicant Details Verification"}
                        extra={
                            [
                                <Button
                                    type={"link"}
                                    onClick={this.props.reloadData}
                                    key={"download-rcu"} 
                                    style={{ marginRight: "10px" }}
                                >
                                    {"Refresh"}
                                </Button>,
                                <Button
                                    type={"primary"}
                                    onClick={this.props.downloadRcuReport}
                                    key={"download-rcu"}
                                >
                                    {"Download RCU Report"}
                                </Button>
                            ]
                        }
                    >
                        <Table
                            columns={this.tableColumns}
                            data={(this.props.associates || new List([])).map(_ => {
                                let row = _;
                                if( _ && _.phone && (!_.phone.verification_status || _.phone.verification_status == "" || _.phone.verification_status == RCU_VERIFICATION_STATUS_TYPES.UNINITIATED)) {
                                    row.is_phone_number_verified = (
                                        <Button
                                            onClick={this.verifyDetails.bind(null, "phone", _)}
                                            type={"link"}
                                        >
                                            {"Verify"}
                                        </Button>
                                    );
                                }
                                if( _ && _.email && (!_.email.verification_status || _.email.verification_status == "" || _.email.verification_status == RCU_VERIFICATION_STATUS_TYPES.UNINITIATED || _.email.verification_status == RCU_VERIFICATION_STATUS_TYPES.INITIATED)) {
                                    row.is_email_verified = (
                                        <Button
                                            onClick={this.verifyDetails.bind(null, "email", _)}
                                            type={"link"}
                                        >
                                            {"Verify"}
                                        </Button>
                                    );
                                }
                                if( _ && _.aadhar) {
                                    if (_.aadhar.document && (!_.aadhar.verification_status || _.aadhar.verification_status == "" || _.aadhar.verification_status == RCU_VERIFICATION_STATUS_TYPES.UNINITIATED)) {
                                        row.is_aadhaar_number_verified = (
                                            <span>
                                                {"Verify"}
                                            </span>
                                        );
                                    }
                                }
                                if(!_.aadhar || !_.aadhar.document) {
                                    row.is_aadhaar_number_verified = (
                                        // <Button type={"link"} onClick={this.toggleDocumentSelectionModal.bind(null, "aadhar")}>
                                        //     Search
                                        // </Button>
                                        <span>
                                            Document Not Available 
                                        </span>
                                    );
                                }
                                if( _ && _.pan) {
                                    if (_.pan.document && (!_.pan.verification_status || _.pan.verification_status == "" || _.pan.verification_status == RCU_VERIFICATION_STATUS_TYPES.UNINITIATED || _.pan.verification_status == RCU_VERIFICATION_STATUS_TYPES.INITIATED)) {
                                        row.is_pan_number_verified = (
                                            <Button
                                                onClick={this.verifyDetails.bind(null, "pan", _)}
                                                type={"link"}
                                            >
                                                {"Verify"}
                                            </Button>
                                        );
                                    }
                                    if(!_.pan.document) {
                                        row.is_pan_number_verified = (
                                            // <Button type={"link"} onClick={this.toggleDocumentSelectionModal.bind(null, "pan")}>
                                            //     Search
                                            // </Button>
                                            <span>
                                                Document Not Available 
                                            </span>
                                        );
                                    }
                                }
                                if(!_.pan) {
                                    row.is_pan_number_verified = (
                                        <span>N/A</span>
                                    );
                                }
                                if( _ && _.phone && (!_.phone.verification_status || _.phone.verification_status == RCU_VERIFICATION_STATUS_TYPES.INITIATED)) {
                                    row.is_phone_number_verified = (
                                        <Button
                                            onClick={this.verifyDetails.bind(null, "phone", _)}
                                            type={"link"}
                                        >
                                            {"Confirm OTP"}
                                        </Button>
                                    );
                                }
                                if( _ && _.email && (!_.email.verification_status || _.email.verification_status == RCU_VERIFICATION_STATUS_TYPES.INITIATED)) {
                                    row.is_email_verified = (
                                        <Button
                                            onClick={this.verifyDetails.bind(null, "email", _)}
                                            type={"link"}
                                        >
                                            {"Confirm OTP"}
                                        </Button>
                                    );
                                }
                                if(_ && _.pan && (_.pan.verification_status && _.pan.verification_status == RCU_VERIFICATION_STATUS_TYPES.VERIFIED)){
                                    row.is_pan_number_verified = (
                                        <span>Verified</span>
                                    );
                                }
                                if(_ && _.aadhar && (_.aadhar.verification_status && _.aadhar.verification_status == RCU_VERIFICATION_STATUS_TYPES.VERIFIED)){
                                    row.is_aadhaar_number_verified = (
                                        <span>Verified</span>
                                    );
                                }
                                if(_ && _.email && (_.email.verification_status && _.email.verification_status == RCU_VERIFICATION_STATUS_TYPES.VERIFIED)){
                                    row.is_email_verified = (
                                        <span>Verified</span>
                                    );
                                }
                                if(_ && _.phone && (_.phone.verification_status && _.phone.verification_status == RCU_VERIFICATION_STATUS_TYPES.VERIFIED)){
                                    row.is_phone_number_verified = (
                                        <span>Verified</span>
                                    );
                                }
                                if(_ && _.pan && (_.pan.verification_status && _.pan.verification_status == RCU_VERIFICATION_STATUS_TYPES.VERIFIED)){
                                    row.is_pan_number_verified = (
                                        <span>Verified</span>
                                    );
                                }
                                if(_ && _.aadhar && (_.aadhar.verification_status && _.aadhar.verification_status == RCU_VERIFICATION_STATUS_TYPES.FAILED)){
                                    row.is_aadhaar_number_verified = (
                                        <span>Failed</span>
                                    );
                                }
                                if(_ && _.pan && (_.pan.verification_status && _.pan.verification_status == RCU_VERIFICATION_STATUS_TYPES.FAILED)){
                                    row.is_pan_number_verified = (
                                        <span>Failed</span>
                                    );
                                }
                                if(_ && _.email && (_.email.verification_status && _.email.verification_status == RCU_VERIFICATION_STATUS_TYPES.FAILED)){
                                    row.is_email_verified = (
                                        <span>Failed</span>
                                    );
                                }
                                if(_ && _.phone && (_.phone.verification_status && _.phone.verification_status == RCU_VERIFICATION_STATUS_TYPES.FAILED)){
                                    row.is_phone_number_verified = (
                                        <span>Failed</span>
                                    );
                                }
                                if(_ && _.pan && (_.pan.verification_status && _.pan.verification_status == RCU_VERIFICATION_STATUS_TYPES.FAILED)){
                                    row.is_pan_number_verified = (
                                        <>
                                        <span>Failed</span>
                                        <Button 
                                            style={{
                                                border : 0,
                                                background : "transparent"
                                            }}
                                            onClick={() => this.props.fetchAssociateList(_.pan.request_id)}
                                        >
                                            <Icon type="redo" />
                                        </Button>
                                        <span>{_.pan && 
                                        _.pan.verification_response &&
                                        _.pan.verification_response.data&& 
                                         _.pan.verification_response.data.upstreamName}</span>
                                        </>
                                    );
                                }
                                return row;
                            })}
                            loading={this.props.loading}
                            showFilters={false}
                            showTopSection={false}
                            size={"small"}
                            showColumnSelector={false}
                            checkedColumns={[]}
                        >
                        </Table>
                    </Card>
                </LoaderSkeleton>
            </React.Fragment>
        );
    }
}

ApplicantVerificationTable.propTypes = {
    associates: PropTypes.object,
    verifyDetails: PropTypes.func,
    loading: PropTypes.bool,
    downloadRcuReport: PropTypes.func,
    reloadData: PropTypes.func,
    documents: PropTypes.array,
    fetchAssociateList: PropTypes.func
};

ApplicantVerificationTable.defaultProps = {
    associates: new Map({})
};

export default (ApplicantVerificationTable);